import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    containerFilters: {
        flexDirection: 'row',
        paddingVertical: 6,
    },
    containerTags: {
        flexGrow: 0,
        flexDirection: 'row',
        backgroundColor: 'white',
        paddingVertical: 0,
    },
    scrollView: {
        flexDirection: 'row',
        flexGrow: 0,
    },
    containerPriceItem: {
        flex: 1,
        flexDirection: 'row',
        margin: 10,
    },
    containerStoreData: {
        paddingTop: 15,
        marginBottom: 5,
        paddingBottom: 20,
    },
    containerDataStore: {
        flexDirection: 'row',
        marginHorizontal: 12,
        marginVertical: 1,
        alignItems: 'center',
        flex: 1,
        color: theme.colors.textPrimary,
    },
    containerDataStoreBis: {
        flexDirection: 'row',
        alignItems: 'center',
        marginEnd: 12,
    },
    containerNameStore: {
        flexDirection: 'row',
        alignItems: 'center',
        marginHorizontal: 12,
        paddingRight: 24,
    },
    storeImage: {
        width: 20,
        height: 20,
        marginRight: 8,
        borderRadius: 5,
        tintColor: 'white',
        verticalAlign: 'top',
    },
    textNameStore: {
        fontSize: 18,
        fontWeight: 'bold',
        color: 'white',
        paddingBottom: 1,
    },
    textAddressStore: {
        fontSize: 14,
        fontWeight: 'normal',
        color: 'white',
        marginHorizontal: 12,
        marginTop: 8,
        marginBottom: 4,
    },
    containerDistance: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 4,
        marginHorizontal: 12,
    },
    textAddressStoreWithGoTo: {
        fontSize: 14,
        //fontWeight: 'bold',
        color: 'white',
        textDecorationLine: 'underline',
        paddingRight: 24,
        marginLeft: 3,
    },
    containerInfoStore: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginHorizontal: 12,
    },
    textInfoStore: {
        fontSize: 14,
        fontWeight: 'normal',
        color: 'white',
        flex: 1,
    },
    textProgressStore: {
        fontSize: 14,
        fontWeight: 'bold',
        color: 'white',
    },
    storecode: {
        fontSize: 13,
        color: 'white',
        marginVertical: 5,
        flex: 1,
    },
    progress: {
        borderRadius: 6,
        marginTop: 10,
        marginBottom: 8,
        marginHorizontal: 12,
        borderColor: theme.colors.colorPrimary,
    },
    containerSection: {
        flex: 1,
        marginHorizontal: 0,
        justifyContent: 'space-between',
    },
    subContainerSection: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1,
        marginBottom: 0,
    },
    containerRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    stamp: {
        flexDirection: 'row',
        borderWidth: 1,
        borderColor: theme.colors.colorPrimary,
        borderRadius: 10,
        paddingHorizontal: 8,
        paddingVertical: 2,
        alignItems: 'center',
    },
    textStamp: {
        fontSize: 12,
        fontWeight: 'bold',
    },
    textSection: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginLeft: 12,
        marginEnd: 6,
    },
    textRequires: {
        fontSize: 12,
        fontWeight: '500',
        color: theme.colors.textPrimary,
    },
    textCheckInOut: {
        fontSize: 12,
        fontWeight: 'bold',
        color: theme.colors.colorSecondary,
    },
    textSectionDescription: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginHorizontal: 12,
        paddingTop: 2,
        marginBottom: 8,
    },
    containerItemsIndicators: {
        alignItems: 'center',
    },
    containerItemsPS: {
        width: width / 4,
        alignItems: 'center',
        paddingBottom: 15,
        marginHorizontal: 0,
    },
    perfectStoreButton: {
        width: width / 3,
        alignItems: 'center',
    },
    iconImage: {
        width: 32,
        height: 32,
        aspectRatio: 1,
        tintColor: theme.colors.colorPrimary,
    },
    containerImage: {
        width: 70,
        height: 70,
        borderColor: 'white',
        borderWidth: 0,
        borderRadius: 90,
        justifyContent: 'center',
        alignItems: 'center',
        rotation: 90,
    },
    image: {
        width: 25,
        height: 25,
    },
    textName: {
        fontSize: 13,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        paddingTop: 5,
    },
    textProgressCircle: {
        fontSize: 13,
        fontWeight: 'bold',
    },
    containerItemsExecution: {
        width: width / 4,
        alignItems: 'center',
        marginHorizontal: 0,
        paddingBottom: 10,
    },
    containerProgress: {
        width: 90,
        height: 50,
        alignItems: 'center',
        alignSelf: 'center',
        justifyContent: 'center',
    },
    iconContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 30,
        width: 60,
        height: 60,
    },
    iconImageExecution: {
        width: 28,
        height: 28,
        aspectRatio: 1,
        tintColor: theme.colors.colorPrimary,
        borderRadius: 0,
        margin: 15,
    },
    textNameExecution: {
        fontSize: 12,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,

        marginTop: 6,
        marginBottom: 3,
        textTransform: 'capitalize',
    },
    textPercentage: {
        fontSize: 13,
        fontWeight: 'bold',
        position: 'absolute',
        zIndex: 5,
        top: 55,
        backgroundColor: 'white',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        padding: 0,
    },
    percentage: {
        fontSize: 14,
        fontWeight: 'bold',
        position: 'absolute',
        zIndex: 2,
        backgroundColor: 'transparent',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        padding: 0,
    },
    containerStatus: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: -12,
    },
    statusFormList: {
        justifyContent: 'center',
        alignContent: 'center',
        paddingHorizontal: 5,
        paddingVertical: 2,
        borderRadius: 10,
        alignSelf: 'flex-start',
        marginTop: 5,
        borderColor: 'red',
        borderWidth: 1,
    },
    textStatus: {
        fontSize: 11,
        textAlign: 'center',
        color: 'white',
    },

    buttonContainer: {
        flexDirection: 'column',
        paddingVertical: 15,
        marginBottom: 12,
        width: '100%',
    },
    borderButton: {
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        paddingVertical: 8,
        paddingHorizontal: 50,
        marginHorizontal: 15,
        marginBottom: 15,
        borderRadius: 10,
    },
    borderButtonText: {
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        fontSize: 15,
        textAlign: 'center',
    },
    mainButton: {
        flexDirection: 'row',
        marginTop: 15,
        marginHorizontal: 15,
        backgroundColor: theme.colors.lightGray,
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainButtonActive: {
        flexDirection: 'row',
        marginTop: 15,
        marginHorizontal: 15,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainButtonText: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    mainButtonTextActive: {
        fontSize: 16,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    linearGradient: {
        flexDirection: 'row',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        marginTop: 0,
        marginHorizontal: 10,
        padding: 12,
        borderWidth: 1,
        borderColor: 'white',
        borderRadius: 12.5,
        flex: 1,
    },
    checkInOutButton: {
        flexDirection: 'row',
        marginHorizontal: 10,
        backgroundColor: theme.colors.colorPrimary,
        borderWidth: 1.5,
        borderColor: 'white',
        padding: 10,
        borderRadius: 12.5,
        alignItems: 'center',
        justifyContent: 'center',
    },
    checkInOutButtonBis: {
        flexDirection: 'row',
        marginTop: 0,
        marginHorizontal: 10,
        backgroundColor: 'white',
        borderWidth: 1.5,
        borderColor: 'white',
        padding: 10,
        borderRadius: 12.5,
        alignItems: 'center',
        justifyContent: 'center',
    },
    floatingButton: {
        flexDirection: 'row',
        backgroundColor: theme.colors.filtersBackground,
        borderRadius: 5,
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: 15,
        marginBottom: 5,
        padding: 10,
    },
    floatingButtonText: {
        color: theme.colors.colorPrimary,
        fontSize: 15,
        fontWeight: 'bold',
        textAlign: 'center',
        marginRight: 5,
    },
    horizontalLine: {
        borderBottomWidth: 2.0,
        borderBottomColor: theme.colors.colorPrimary,
        width: 130,
        alignSelf: 'center',
        marginHorizontal: 12,
        marginTop: 1,
        marginBottom: 12,
    },
    floatingButtonIcon: {
        width: 16,
        height: 16,
        tintColor: theme.colors.colorPrimary,
    },
    product: {
        color: theme.colors.textPrimary,
        fontWeight: 'normal',
        textAlign: 'left',
    },
    ean: {
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        marginTop: 5,
    },
    price: {
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
    },
    titleSection: {
        fontSize: 16,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingHorizontal: 10,
        paddingVertical: 5,
    },
    vouchersModule: {
        flex: 1,
        flexDirection: 'row',
        padding: 10,
        marginHorizontal: 10,
        marginVertical: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: theme.colors.modalBackground,
    },
    voucherImage: {
        width: 65,
        marginVertical: 10,
        marginRight: 10,
        aspectRatio: 1,
        alignItems: 'center',
        borderRadius: 10,
    },
    voucherDescriptions: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    voucherTitle: {
        fontSize: 16,
        marginRight: 10,
        marginBottom: 5,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
    },
    voucherDescription: {
        fontSize: 15,
        marginRight: 10,
        marginBottom: 5,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    voucherPoints: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.colorSecondary,
    },
    voucherVigency: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.colorSecondary,
        alignSelf: 'center',
    },
    contentContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 0,
    },
    mediaContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    infoContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        marginVertical: 10,
        paddingHorizontal: 15,
        color: theme.colors.textPrimary,
        textAlign: 'center',
    },
    description: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        marginVertical: 10,
        paddingHorizontal: 25,
        textAlign: 'center',
        lineHeight: 20,
    },
    benefitAsset: {
        width: 200,
        height: 200,
        margin: 10,
        alignSelf: 'center',
    },
    titleQR: {
        fontSize: 22,
        fontWeight: 'bold',
        marginVertical: 10,
        paddingHorizontal: 15,
        color: theme.colors.colorPrimary,
        textAlign: 'center',
    },
    titleQRscaner: {
        fontSize: 18,
        fontWeight: 'bold',
        marginVertical: 10,
        paddingHorizontal: 15,
        color: theme.colors.colorApproved,
        textAlign: 'center',
    },
    containerNoMessage: {
        justifyContent: 'center',
        alignItems: 'center',
        height: '80%',
    },
    imageNoMessage: {
        width: 120,
        height: 120,
    },
    titleNoMessage: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 6,
        marginTop: 10,
        paddingHorizontal: 40,
    },
    descriptionNoMessage: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 40,
    },
    dividerHorizontalLine: {
        width: '100%',
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        marginVertical: 10,
    },
    containerIndicator: {
        width: 120,
        borderRadius: 20,
        padding: 12,
        marginLeft: 8,
        justifyContent: 'center',
    },
    textIndicatorName: {
        fontSize: 11,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        textAlign: 'center',
        color: 'white',
        paddingBottom: 5,
        paddingTop: 5,
    },
    textIndicatorData: {
        fontSize: 40,
        fontWeight: 'bold',
        color: 'white',
        marginBottom: 5,
    },
    textVariation: {
        fontSize: 13,
        fontWeight: 'normal',
        color: 'white',
        paddingTop: 15,
    },
    textViariationData: {
        fontSize: 13,
        fontWeight: 'bold',
        color: 'white',
    },
    messageContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        padding: 10,
        marginVertical: 10,
        borderRadius: 5,
    },
    imageAsset: {
        width: 120,
        height: 120,
    },
    titleText: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 25,
    },
    descriptionText: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 25,
        paddingBottom: 12,
    },
    containerButton: {
        flexDirection: 'column',
        position: 'absolute',
        padding: 5,
        bottom: 15,
        width: '100%',
    },
    button: {
        marginHorizontal: 12,
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    textButton: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    buttonCancel: {
        margin: 12,
        backgroundColor: 'white',
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        padding: 8,
        borderRadius: 10,
    },
    textCancel: {
        fontSize: 16,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    flexDirectionRow: { flexDirection: 'row', alignItems: 'center' },
    flexDirectionColumn: { flexDirection: 'column', alignItems: 'flex-start' },
    flatList: { flex: 1, marginTop: 8 },
    marginStart: { marginStart: 5 },
    marginLeft: { marginLeft: 3 },
    marginLeftIcon: { marginLeft: 8 },
    marginRight: { marginRight: 4 },
    marginTop: { marginTop: 8 },
    marginTop1: { marginTop: 12 },
    marginTop2: { marginTop: 4 },
    marginTopBis: { marginTop: 30 },
    marginHorizontal: { marginHorizontal: 5 },
    maxWidth: { maxWidth: '90%' },
    height: { height: 190 },
    colorWhite: { color: 'white' },
    alignCenter: { alignItems: 'center' },
    separator: { height: 6 },
    spacer: { height: 110 },
    spacer1: { height: 24 },
    marginBottom: { marginBottom: 5 },
    marginBottom1: { marginBottom: 2 },
    marginRightExecution: { marginRight: 7 },
    marginRightExecution2: { marginRight: 10 },
    marginLeftExecution: { marginLeft: 1 },
})

export default styles
